import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useDispatch } from 'react-redux'
import { postResendPassword } from '../../../serviceAPI/senha'

export default function FormDialog(props) {
	const dispatch = useDispatch();
	const open = props.open

	const [email, setEmail] = React.useState('');

	const handleClose = props.close

	onsubmit = (event) => {
		event.preventDefault()
		handleClose()
		postResendPassword(email, dispatch);
	}

	return (
		<div>
			<Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title">Recuperação de senha</DialogTitle>
				<form>
					<DialogContent>
						<DialogContentText>
							Para recuperar a senha digite seu e-mail abaixo para receber as instruções.
						</DialogContentText>
						<TextField
							autoFocus
							margin="dense"
							id="name"
							label="E-mail"
							type="email"
							value={email}
							onChange={e => setEmail(e.target.value)}
							fullWidth
							required
						/>
					</DialogContent>
					<DialogActions>
						<Button onClick={handleClose} color="primary">
							Cancelar
						</Button>
						<Button type='submit' color="primary">
							Enviar
						</Button>
					</DialogActions>
				</form>
			</Dialog>
		</div>
	);
}
